import { IDeliverables } from '@digital-office/common/interfaces';

const calculateDeliverableProgress = (deliverables: IDeliverables[]) => {
  const deliveredAmount = deliverables.filter((deliverable) => deliverable.finished);

  return Math.floor((100 * deliveredAmount.length) / deliverables.length);
};

export { calculateDeliverableProgress };
